export default __webpack_public_path__ + "static/media/JeVivroieLiement-GuillaumeDeMachaut.e34985eb.mp3";